import appConfig from '../config/appConfig.json'

export function getBoundaries(location) {

    const url = process.env.REACT_APP_SCHOOL_BOUNDARY;
    const promise = new Promise((resolve, reject) => {

        var bodyStr = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tem="http://tempuri.org/"> 
            <soapenv:Header/>
            <soapenv:Body>
            <tem:findSchoolsNew>
                <tem:x>${location.x}</tem:x>
                <tem:y>${location.y}</tem:y>
                <tem:f>xml</tem:f>
            </tem:findSchoolsNew>
            </soapenv:Body>
        </soapenv:Envelope>`
      // fetch mar 2 data
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'text/xml'
        },
        body: bodyStr
      })
      .then(
          res => {
            return res.json();
          },
          () => reject('An unexpected problem occured')
      )
      .then(data => {
          if (!data) {
            reject('No results...');
          } else {
            try {
                if (data['soap:Envelope']['soap:Body']['findSchoolsNewResponse']['findSchoolsNewResult']['errorMessage'] === "") {
                    // resolve(data['soap:Envelope']['soap:Body']['findSchoolsNewResponse']['findSchoolsNewResult']['newBoundarySchools']);
                    resolve(data['soap:Envelope']['soap:Body']['findSchoolsNewResponse']['findSchoolsNewResult']);

                  }
            }
            catch{
                reject('Error from boundary service')
            }
          }
        });
    });
    return promise;
}

export function getBoundaryPolygons(location, type) {
  // get all in type array
  let esVal = appConfig.boundaryPolygons.esLayer;
  let msVal = appConfig.boundaryPolygons.msLayer;
  let hsVal = appConfig.boundaryPolygons.hsLayer;

  let promises = [];
  if (type.includes("ES")) {
    promises.push(getBoundaryGeoJSON(location, esVal, "ES"));
  }
  if (type.includes("MS")) {
    promises.push(getBoundaryGeoJSON(location, msVal, "MS"));
  }
  if (type.includes("HS")) {
    promises.push(getBoundaryGeoJSON(location, hsVal, "HS"));
  }

  return Promise.allSettled(promises);
}

function getBoundaryGeoJSON(location, layerid, layerType) {

  // update url with replaced values for ESRI map service search
  // return features
  const url = appConfig.boundaryPolygons.url
  const boundaryURL = url.replace("inputCoords", location.lon + "," + location.lat).replace("layerID", layerid);
  const promise = new Promise((resolve, reject) => {
    fetch(boundaryURL)
    .then((response) => {
        if (response.ok) {
          return response.json();
        }
        return reject(response);
      }
    )
    .then(data => {
        if (!data) {
          reject('No results...');
        } else {
          try {
            resolve({ 
              data: data.features,
              layerType: layerType
            });
          }
          catch{
            reject('Error from boundary polygon service')
          }
        }
      });
  });
  return promise;
}